import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { C, FONT } from '../theme/tokens';
import CleanroomOverviewScreen from '../screens/CleanroomOverviewScreen';
import CleanroomAirChangesScreen from '../screens/cleanroom/CleanroomAirChangesScreen';
import CleanroomParticleCountingScreen from '../screens/cleanroom/CleanroomParticleCountingScreen';
import CleanroomClassificationsScreen from '../screens/cleanroom/CleanroomClassificationsScreen';
import CleanroomFormulasScreen from '../screens/cleanroom/CleanroomFormulasScreen';
import CleanroomCalculationsScreen from '../screens/cleanroom/CleanroomCalculationsScreen';
import CleanroomAirChangesPerHourScreen from '../screens/cleanroom/calculations/CleanroomAirChangesPerHourScreen';
import CleanroomParticleConcentrationScreen from '../screens/cleanroom/calculations/CleanroomParticleConcentrationScreen';
import CleanroomScanRateScreen from '../screens/cleanroom/CleanroomScanRateScreen';
import CleanroomParticleCountCalculatorScreen from '../screens/cleanroom/calculations/CleanroomParticleCountCalculatorScreen';
import CleanroomUpstreamChallengeScreen from '../screens/cleanroom/calculations/CleanroomUpstreamChallengeScreen';

const Stack = createStackNavigator();

function useStackScreenOptions() {
  return {
    headerStyle: { backgroundColor: C.panel },
    headerTintColor: C.ink,
    headerTitleStyle: {
      fontFamily: FONT.sansBold,
      fontSize: 16,
      color: C.ink,
    },
    headerShadowVisible: false,
    headerBackTitleVisible: false,
    cardStyle: { backgroundColor: C.bg },
  };
}

export default function CleanroomNavigator() {
  const screenOptions = useStackScreenOptions();
  return (
    <Stack.Navigator screenOptions={screenOptions}>
      <Stack.Screen name="CleanroomCalculations" component={CleanroomCalculationsScreen} options={{ title: 'Cleanroom Calculations' }} />
      <Stack.Screen name="CleanroomOverview" component={CleanroomOverviewScreen} options={{ title: 'Cleanroom Testing' }} />
      <Stack.Screen name="CleanroomAirChanges" component={CleanroomAirChangesScreen} options={{ title: 'Air Changes' }} />
      <Stack.Screen name="CleanroomParticleCounting" component={CleanroomParticleCountingScreen} options={{ title: 'Particle Counting' }} />
      <Stack.Screen name="CleanroomClassifications" component={CleanroomClassificationsScreen} options={{ title: 'Classifications' }} />
      <Stack.Screen name="CleanroomFormulas" component={CleanroomFormulasScreen} options={{ title: 'Cleanroom Formulas' }} />
      <Stack.Screen name="CleanroomAirChangesPerHour" component={CleanroomAirChangesPerHourScreen} options={{ title: 'Air Changes Per Hour' }} />
      <Stack.Screen name="CleanroomParticleConcentration" component={CleanroomParticleConcentrationScreen} options={{ title: 'Particle Concentration' }} />
      <Stack.Screen name="CleanroomScanRate" component={CleanroomScanRateScreen} options={{ title: 'HEPA Scan Rate' }} />
      <Stack.Screen name="CleanroomParticleCountCalculator" component={CleanroomParticleCountCalculatorScreen} options={{ title: 'ISO 14644-1 Particle Count' }} />
      <Stack.Screen name="CleanroomUpstreamChallenge" component={CleanroomUpstreamChallengeScreen} options={{ title: 'Upstream Challenge' }} />
    </Stack.Navigator>
  );
}
